<template>
    <div class="container microsite-cms">
        <div class="row top-buttons" v-show="loading === false">
            <div class="col-lg-12 text-right">
                <a href="/microsites" class="btn btn-default">Back</a>
                <button class="btn btn-success" @click.prevent="save">Save</button>
                <button class="btn btn-primary" @click.prevent="showSettings()" v-show="isModeEdit">
                    Settings
                </button>
            </div>
        </div>
        <div class="row" v-show="loading">
            <div class="col-lg-12 text-center">
                <h2>Loading...</h2>
            </div>
        </div>
        <div class="row" v-show="loading === false">
            <div class="col-lg-12" v-show="isModeCreateOrEdit">
                <div class="form-group">
                    <label for="template">Template</label>
                    <select id="template" class="form-control" v-model="microsite.template_id">
                        <option v-for="template in templates" :value="template.id">{{ template.name }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="agency">Agency</label>
                    <treeselect
                        :options="agencies"
                        :normalizer="agencyTreeSelectNormalizer"
                        :searchable="true"
                        value-consists-of="LEAF_PRIORITY"
                        v-model="microsite.agency_id"
                        id="agency"
                    ></treeselect>
                </div>
                <div class="form-group" v-show="isModeCreate">
                    <button class="btn btn-primary" @click.prevent="createMicrosite">Continue</button>
                </div>
            </div>
            <div class="col-lg-12" v-show="isModeEdit">
                <div class="form-group">
                    <label for="logo">Logo</label>
                    <input type="file" id="logo" @change="updateFile($event, 'logo')">
                    <img :src="microsite.logo_url" alt="" v-if="hasLogo" style="max-width: 100%; max-height: 200px;">
                    <br/>
                    <button @click.prevent="removeLogo" v-if="hasLogo" class="btn btn-danger">Remove Logo</button>
                </div>
                <div class="form-group">
                    <label for="background">Background Image</label>
                    <input type="file" id="background" @change="updateFile($event, 'background')">
                    <img :src="microsite.background_url" alt="" v-if="hasBackground" style="max-width: 100%; max-height: 200px;">
                    <br/>
                    <button @click.prevent="removeBackground" v-if="hasBackground" class="btn btn-danger">Remove Background Image</button>
                </div>
                <div class="form-group">
                    <label for="image_1">Image 1</label>
                    <input type="file" id="image_1" @change="updateFile($event, 'image_1')">
                    <img :src="microsite.image_1_url" alt="" v-if="hasImage1" style="max-width: 100%; max-height: 200px;">
                    <br/>
                    <button @click.prevent="removeImage1" v-if="hasImage1" class="btn btn-danger">Remove Image 1</button>
                </div>
                <div class="form-group">
                    <label for="image_2">Image 2</label>
                    <input type="file" id="image_2" @change="updateFile($event, 'image_2')">
                    <img :src="microsite.image_2_url" alt="" v-if="hasImage2" style="max-width: 100%; max-height: 200px;">
                    <br/>
                    <button @click.prevent="removeImage2" v-if="hasImage2" class="btn btn-danger">Remove Image 2</button>
                </div>
                <div class="form-group">
                    <label for="image_3">Image 3</label>
                    <input type="file" id="image_3" @change="updateFile($event, 'image_3')">
                    <img :src="microsite.image_3_url" alt="" v-if="hasImage3" style="max-width: 100%; max-height: 200px;">
                    <br/>
                    <button @click.prevent="removeImage3" v-if="hasImage3" class="btn btn-danger">Remove Image 3</button>
                </div>
                <ifp-input-text v-model="microsite.seo_title" label="Seo Title" :with-count="true" count-label="/ 60"></ifp-input-text>
                <ifp-textarea v-model="microsite.seo_description" label="Seo Description" :with-count="true" count-label="/ 160"/>
                <ifp-input-text v-model="microsite.h1" label="Page Title (H1)"></ifp-input-text>
                <ifp-input-text v-model="microsite.block_1_header" label="Block 1 Header"></ifp-input-text>
                <ifp-textarea v-model="microsite.block_1_content" label="Block 1 Content"/>
                <ifp-input-text v-model="microsite.block_2_header" label="Block 2 Header"></ifp-input-text>
                <ifp-textarea v-model="microsite.block_2_content" label="Block 2 Content"/>
                <ifp-input-text v-model="microsite.block_3_header" label="Block 3 Header"></ifp-input-text>
                <ifp-textarea v-model="microsite.block_3_content" label="Block 3 Content"/>
                <ifp-textarea v-model="microsite.block_address" label="Block Address"/>
                <ifp-input-text v-model="microsite.latest_properties_title" label="Latest Properties Title"></ifp-input-text>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model="microsite.active"> Active
                    </label>
                </div>

                <div class="form-group">
                    <a href="/microsites" class="btn btn-default">Back</a>
                    <button class="btn btn-success" @click.prevent="save">Save</button>
                </div>
            </div>
        </div>

        <modal class="settings" @close="settings = false" v-show="isShowSettings">
            <template slot="header"><h3 style="margin: 0">Settings</h3></template>
            <template slot="top-right">
                <button class="btn btn-success" @click.prevent="save">Save</button>
            </template>
            <template slot="body">
                <div class="col-lg-4">
                    <ifp-input-text default-value="#f8f8f8" :isColor="true" v-model="microsite.settings_body_colour"
                                    label="Body Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="#ffffff" :isColor="true" v-model="microsite.settings_content_background_colour"
                                    label="Content Background Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="#333333" :isColor="true" v-model="microsite.settings_text_colour"
                                    label="Text Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value='"Helvetica Neue",Helvetica,Arial,sans-serif' v-model="microsite.settings_font_family"
                                    label="Font Family"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label for="settings_page_size">Page Size</label>
                        <select id="settings_page_size" class="form-control" v-model="microsite.settings_page_size">
                            <option v-for="num in [1,2,3,4,5,6]" :value="num">{{ num }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="#337ab7" :isColor="true" v-model="microsite.settings_link_colour"
                                    label="Link Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="Link Colour" :isColor="true" v-model="microsite.settings_button_colour"
                                    label="Button Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="Link Colour" :isColor="true" v-model="microsite.settings_icon_colour"
                                    label="Icon Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="Button Colour" :isColor="true" v-model="microsite.settings_button_send_colour"
                                    label="Button Send Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="Button Colour" :isColor="true" v-model="microsite.settings_button_latest_colour"
                                    label="Button Latest Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="#ffffff" :isColor="true" v-model="microsite.settings_checkbox_colour"
                                    label="Checkbox Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="#333333" :isColor="true" v-model="microsite.settings_checkbox_text_colour"
                                    label="Checkbox Text Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="#45b11c" :isColor="true" v-model="microsite.settings_checkbox_active_colour"
                                    label="Checkbox Active Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="#ffffff" :isColor="true" v-model="microsite.settings_checkbox_active_text_colour"
                                    label="Checkbox Active Text Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="0px" v-model="microsite.settings_border_width" label="Border Width"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="Content Background Colour" :isColor="true" v-model="microsite.settings_border_colour"
                                    label="Border Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="darken(Body Colour, 10%)" :isColor="true" v-model="microsite.settings_footer_colour"
                                    label="Footer Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="Text Colour" :isColor="true" v-model="microsite.settings_footer_text_colour"
                                    label="Footer Text Colour"></ifp-input-text>
                </div>
                <div class="col-lg-4">
                    <ifp-input-text default-value="Link Colour" :isColor="true" v-model="microsite.settings_footer_link_colour"
                                    label="Footer Link Colour"></ifp-input-text>
                </div>
                <div class="col-lg-12">
                    <ifp-textarea v-model="microsite.settings_custom_css" label="Custom CSS"></ifp-textarea>
                </div>
            </template>
            <template slot="footer">
                <button class="btn btn-success" @click.prevent="save">Save</button>
                <button class="btn btn-default" @click="settings = false">
                    Close
                </button>
            </template>
        </modal>
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
    name: "microsite-form",
    props: {
        micrositeId: {
            type: Number,
            default: 0,
            required: false,
        },
    },
    components: {Treeselect},
    data() {
        return {
            loading: true,
            mode: 'create',
            settings: false,
            agencies: [],
            templates: [],
            microsite: {
                id: 0,
                active: false,
                template_id: '',
                agency_id: null,
                logo_path: '',
                logo_url: '',
                background_path: '',
                background_url: '',
                image_1_path: '',
                image_1_url: '',
                image_2_path: '',
                image_2_url: '',
                image_3_path: '',
                image_3_url: '',
                seo_title: '',
                seo_description: '',
                block_1_header: '',
                block_1_content: '',
                block_2_header: '',
                block_2_content: '',
                block_3_header: '',
                block_3_content: '',
                block_address: '',
                h1: '',
                latest_properties_title: '',
                settings_page_size: '',
                settings_body_colour: '',
                settings_content_background_colour: '',
                settings_link_colour: '',
                settings_icon_colour: '',
                settings_border_width: '',
                settings_border_colour: '',
                settings_button_latest_colour: '',
                settings_footer_text_colour: '',
                settings_footer_link_colour: '',
                settings_text_colour: '',
                settings_font_family: '',
                settings_button_colour: '',
                settings_button_send_colour: '',
                settings_checkbox_colour: '',
                settings_checkbox_text_colour: '',
                settings_checkbox_active_colour: '',
                settings_checkbox_active_text_colour: '',
                settings_footer_colour: '',
                settings_custom_css: '',
            },
            files: {
                logo: null,
                background: null,
                image_1: null,
                image_2: null,
                image_3: null,
            },
            remove_image: {
                logo: false,
                background: false,
                image_1: false,
                image_2: false,
                image_3: false,
            },
        };
    },
    created() {
        Promise.all([this.getAgencies(), this.getTemplates()])
            .then(() => {
                if (this.micrositeId === 0) {
                    this.mode = 'create';
                    this.loading = false;
                    return;
                }

                this.getMicrosite()
                    .then(() => {
                        this.mode = 'edit';
                        this.loading = false;
                    });
            });
    },
    computed: {
        isModeCreate() {
            return this.mode === 'create';
        },
        isModeEdit() {
            return this.mode === 'edit';
        },
        isModeCreateOrEdit() {
            return this.isModeCreate || this.isModeEdit;
        },
        isShowSettings() {
            return this.settings;
        },
        hasLogo() {
            return this.microsite.hasOwnProperty('logo_url') && this.microsite.logo_url !== null;
        },
        hasBackground() {
            return this.microsite.hasOwnProperty('background_url') && this.microsite.background_url !== null;
        },
        hasImage1() {
            return this.microsite.hasOwnProperty('image_1_url') && this.microsite.image_1_url !== null;
        },
        hasImage2() {
            return this.microsite.hasOwnProperty('image_2_url') && this.microsite.image_2_url !== null;
        },
        hasImage3() {
            return this.microsite.hasOwnProperty('image_3_url') && this.microsite.image_3_url !== null;
        },
    },
    methods: {
        getAgencies() {
            return new Promise(resolve => {
                axios.get('/microsites/agencies')
                    .then(response => {
                        this.agencies = response.data;
                        resolve();
                    });
            })
        },
        getTemplates() {
            return new Promise(resolve => {
                axios.get('/microsites/templates/data')
                    .then(response => {
                        this.templates = response.data;
                        resolve();
                    });
            })
        },
        getMicrosite() {
            return axios.get('/microsites/' + this.micrositeId)
                .then(response => {
                    this.microsite = response.data;
                });
        },
        agencyTreeSelectNormalizer(agency) {
            return {
                id: agency.id,
                label: agency.name + ' (' + agency.id + ')'
            }
        },
        createMicrosite() {
            axios.post('/microsites/create', {agency_id: this.microsite.agency_id, template_id: this.microsite.template_id})
                .then(response => {
                    this.microsite = response.data;
                    this.mode = 'edit';
                    window.history.pushState({}, '', '/microsites/' + this.microsite.id + '/edit');
                });

        },
        showSettings() {
            this.settings = true;
        },
        updateFile(event, property) {
            this.files[property] = event.target.files[0];
        },
        save() {
            axios.post('/microsites/' + this.microsite.id, this.getSaveData(), this.getSaveHeaders())
                .then(response => {
                    this.microsite = response.data;

                    if ([false, 'false', 0, '0'].some(a => response.data.active === a)) {
                        this.microsite.active = false;
                    } else if ([true, 'true', 1, '1'].some(a => response.data.active === a)) {
                        this.microsite.active = true;
                    }

                    this.files = {
                        logo: null,
                        background: null,
                        image_1: null,
                        image_2: null,
                        image_3: null,
                    };
                    this.remove_image = {
                        logo: false,
                        background: false,
                        image_1: false,
                        image_2: false,
                        image_3: false,
                    };
                    this.$toasted.success('Microsite Saved', {icon: 'check-circle'});
                });
        },
        getSaveData() {
            let data = new FormData();
            data.append('id', this.microsite.id);
            data.append('active', this.microsite.active);
            data.append('template_id', this.microsite.template_id);
            data.append('agency_id', this.microsite.agency_id);
            data.append('seo_title', this.microsite.seo_title);
            data.append('seo_description', this.microsite.seo_description);
            data.append('h1', this.microsite.h1);
            data.append('latest_properties_title', this.microsite.latest_properties_title);
            data.append('block_1_header', this.microsite.block_1_header);
            data.append('block_1_content', this.microsite.block_1_content);
            data.append('block_2_header', this.microsite.block_2_header);
            data.append('block_2_content', this.microsite.block_2_content);
            data.append('block_3_header', this.microsite.block_3_header);
            data.append('block_3_content', this.microsite.block_3_content);
            data.append('block_address', this.microsite.block_address);
            data.append('settings_page_size', this.microsite.settings_page_size);
            data.append('settings_body_colour', this.microsite.settings_body_colour);
            data.append('settings_content_background_colour', this.microsite.settings_content_background_colour);
            data.append('settings_link_colour', this.microsite.settings_link_colour);
            data.append('settings_icon_colour', this.microsite.settings_icon_colour);
            data.append('settings_border_width', this.microsite.settings_border_width);
            data.append('settings_border_colour', this.microsite.settings_border_colour);
            data.append('settings_button_latest_colour', this.microsite.settings_button_latest_colour);
            data.append('settings_footer_text_colour', this.microsite.settings_footer_text_colour);
            data.append('settings_footer_link_colour', this.microsite.settings_footer_link_colour);
            data.append('settings_text_colour', this.microsite.settings_text_colour);
            data.append('settings_font_family', this.microsite.settings_font_family);
            data.append('settings_button_colour', this.microsite.settings_button_colour);
            data.append('settings_button_send_colour', this.microsite.settings_button_send_colour);
            data.append('settings_checkbox_colour', this.microsite.settings_checkbox_colour);
            data.append('settings_checkbox_text_colour', this.microsite.settings_checkbox_text_colour);
            data.append('settings_checkbox_active_colour', this.microsite.settings_checkbox_active_colour);
            data.append('settings_checkbox_active_text_colour', this.microsite.settings_checkbox_active_text_colour);
            data.append('settings_footer_colour', this.microsite.settings_footer_colour);
            data.append('settings_custom_css', this.microsite.settings_custom_css);

            if (this.files.logo !== null) {
                data.append('logo', this.files.logo, this.files.logo.name);
            }

            if (this.files.background !== null) {
                data.append('background', this.files.background, this.files.background.name);
            }

            if (this.files.image_1 !== null) {
                data.append('image_1', this.files.image_1, this.files.image_1.name);
            }

            if (this.files.image_2 !== null) {
                data.append('image_2', this.files.image_2, this.files.image_2.name);
            }

            if (this.files.image_3 !== null) {
                data.append('image_3', this.files.image_3, this.files.image_3.name);
            }

            if (this.remove_image.logo === true) {
                data.append('remove_logo', true);
            }

            if (this.remove_image.background === true) {
                data.append('remove_background', true);
            }

            if (this.remove_image.image_1 === true) {
                data.append('remove_image_1', true);
            }

            if (this.remove_image.image_2 === true) {
                data.append('remove_image_2', true);
            }

            if (this.remove_image.image_3 === true) {
                data.append('remove_image_3', true);
            }

            return data;
        },
        getSaveHeaders() {
            return {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
        },
        removeLogo() {
            this.remove_image.logo = true;
            this.microsite.logo_path = null;
            if (this.microsite.hasOwnProperty('logo_url')) {
                this.microsite.logo_url = null;
            }
        },
        removeBackground() {
            this.remove_image.background = true;
            this.microsite.background_path = null;
            if (this.microsite.hasOwnProperty('background_url')) {
                this.microsite.background_url = null;
            }
        },
        removeImage1() {
            this.remove_image.image_1 = true;
            this.microsite.image_1_path = null;
            if (this.microsite.hasOwnProperty('image_1_url')) {
                this.microsite.image_1_url = null;
            }
        },
        removeImage2() {
            this.remove_image.image_2 = true;
            this.microsite.image_2_path = null;
            if (this.microsite.hasOwnProperty('image_2_url')) {
                this.microsite.image_2_url = null;
            }
        },
        removeImage3() {
            this.remove_image.image_3 = true;
            this.microsite.image_3_path = null;
            if (this.microsite.hasOwnProperty('image_3_url')) {
                this.microsite.image_3_url = null;
            }
        },
    },
    watch: {}
}
</script>

<style scoped>

</style>